import React from "react";
import { MotifToast } from "../../../assets/lib/motif";
export function ToastMessage({ variant, message, onClose, className=''}) {
  return (
    <MotifToast className={className} variant={variant} onClose={() => onClose} position="top">
      {message}
    </MotifToast>
  );
}
